import React, { FC } from 'react';

import './Fields.css';
import clsx from 'clsx';

import { FieldValidationMessage } from '../fieldValidationMessage/FieldValidationMessage';
import { FormControlLabel } from '../label';
import { Textbox, TextboxProps } from '../textbox/textbox';

export type TextFieldProps = {
	id: string;
	title: string;
	errorMessage?: string;
	infoMessage?: string;
	currencyCode?: string;
	currencySymbol?: string;
	classes?: {
		input: string;
		label: string;
		validation: string;
	};
} & TextboxProps;

export const TextField: FC<TextFieldProps> = ({
	id,
	title,
	classes,
	invalid,
	currencyCode,
	currencySymbol,
	errorMessage,
	infoMessage,
	acceptanceTestTargetId = id,
	required,
	...rest
}) => (
	<FormControlLabel
		acceptanceTestTargetId={acceptanceTestTargetId ? `${acceptanceTestTargetId}-label` : undefined}
		formControlId={id}
		required={required}
		title={title}
	>
		<Textbox
			{...rest}
			acceptanceTestTargetId={acceptanceTestTargetId}
			className={clsx(classes?.input, invalid && 'form-control-invalid')}
			id={id}
			invalid={invalid}
		/>
		{infoMessage && !invalid && (
			<FieldValidationMessage
				acceptanceTestTargetId={acceptanceTestTargetId ? `${acceptanceTestTargetId}-message` : undefined}
				className={clsx(classes?.validation)}
				errorMessage={infoMessage}
				id={`${id}-message`}
			/>
		)}
		<FieldValidationMessage
			acceptanceTestTargetId={acceptanceTestTargetId ? `${acceptanceTestTargetId}-message` : undefined}
			className={clsx(classes?.validation, invalid && 'field-error')}
			errorMessage={errorMessage}
			id={`${id}-message`}
		/>
	</FormControlLabel>
);
